import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import {AuthenticationService} from "../../_services/authentication.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-two-factor-auth',
  templateUrl: './two-factor-auth.component.html'
})
export class TwoFactorAuthComponent implements OnInit {
  environment = environment;
  codice: string;
  constructor(
    private authsvc : AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  verify() {
    this.authsvc.verify({key:parseInt(this.codice)}).subscribe(()=> {
      var old = this.authsvc.currentUserValue;
      old.verified = true;
      localStorage.setItem('currentUser', JSON.stringify(old));
      this.authsvc.updateuser(old);
      if (this.authsvc?.currentUserValue?.ruoliObject.find(x => x.id == "AC" || x.id == "C" || x.id == "CA" ) != undefined)
        this.router.navigate([this.route.snapshot.queryParams["/Cliente/profile"] || "/Cliente/profile",])
      else if (this.authsvc?.currentUserValue)
        this.router.navigate([this.route.snapshot.queryParams[environment.baseUrl] || environment.baseUrl,])
    },error => {

    })
  }
  resend(){
    this.authsvc.method({method: 'm'}).subscribe()
  }
}
